module.exports = __webpack_public_path__ + "static/media/DqEveryChildOfflineComicBooks.b6c61be4.jpg";